<template>
    <div class="image-list">
        <div :key="index" v-for="(image, index) in images" class="image-item" v-bind:class="{'image-item--small' : imageSize}">
            <image-item :image="image" :building-id="buildingId"/>
        </div>
    </div>
</template>

<script>

import ImageItem from '@/modules/ProjectModule/modules/OptionModule/components/Building/Image/ImageItem';

export default {
    name:       'ImageList',
    components: { ImageItem },
    props:      {
        images:     {
            type:     Array,
            required: true,
        },
        buildingId: {
            type:     String,
            required: true,
        },
        imageSize:  {
            type:     String,
            required: false,
            default:  () => null
        }
    }
}
</script>
